module.exports = __webpack_public_path__ + "static/testimonies-bc749c16da9a38ddda13ee8c6340dd4c.jpg";